var munchBoxItems = {
    'standard': {
        id: 1,
        name: 'Standard',
        snacks: "5-7",
        drinks: 0,
        monthly: {
            id: 7042769518748,
            variants: {
                regular: {
                    id: boxPrices['7042769518748'].regular.id,
                    price: boxPrices['7042769518748'].regular.price,
                    selling_plan: 1162543260
                },
                priority_processing: {
                    id: boxPrices['7042769518748'].pp.id,
                    price: boxPrices['7042769518748'].pp.price,
                    selling_plan: 1162543260
                }
            }
        },
        prepay: {
            "6": {
                id: 7042772959388,
                months: 6,
                variants: {
                    regular: {
                        id: boxPrices['7042772959388'].regular.id,
                        price: boxPrices['7042772959388'].regular.price,
                        selling_plan: 1163952284
                    },
                    priority_processing: {
                        id: boxPrices['7042772959388'].pp.id,
                        price: boxPrices['7042772959388'].pp.price,
                        selling_plan: 1163952284
                    }
                }
            },
            "12": {
                id: 7042774958236,
                months: 12,
                variants: {
                    regular: {
                        id: boxPrices['7042774958236'].regular.id,
                        price: boxPrices['7042774958236'].regular.price,
                        selling_plan: 1162346652
                    },
                    priority_processing: {
                        id: boxPrices['7042774958236'].pp.id,
                        price: boxPrices['7042774958236'].pp.price,
                        selling_plan: 1162346652
                    }
                }
            }
        }
    },
    'premium': {
        id: 2,
        name: 'Premium',
        snacks: "10-12",
        drinks: 0,
        monthly: {
            id: 7042776662172,
            variants: {
                regular: {
                    id: boxPrices['7042776662172'].regular.id,
                    price: boxPrices['7042776662172'].regular.price,
                    selling_plan: 1162313884
                },
                priority_processing: {
                    id: boxPrices['7042776662172'].pp.id,
                    price: boxPrices['7042776662172'].pp.price,
                    selling_plan: 1162313884
                }
            }
        },
        prepay: {
            "3": {
                id: 7042782134428,
                months: 3,
                variants: {
                    regular: {
                        id: boxPrices['7042782134428'].regular.id,
                        price: boxPrices['7042782134428'].regular.price,
                        selling_plan: 1163296924
                    },
                    priority_processing: {
                        id: boxPrices['7042782134428'].pp.id,
                        price: boxPrices['7042782134428'].pp.price,
                        selling_plan: 1163296924
                    }
                }
            },
            "6": {
                id: 7042785968284,
                months: 6,


                variants: {
                    regular: {
                        id: boxPrices['7042785968284'].regular.id,
                        price: boxPrices['7042785968284'].regular.price,
                        selling_plan: 1162117276
                    },
                    priority_processing: {
                        id: boxPrices['7042785968284'].pp.id,
                        price: boxPrices['7042785968284'].pp.price,
                        selling_plan: 1162117276
                    }
                }
            },
            "12": {
                id: 7042789048476,
                months: 12,
                variants: {
                    regular: {
                        id: boxPrices['7042789048476'].regular.id,
                        price: boxPrices['7042789048476'].regular.price,
                        selling_plan: 1163853980
                    },
                    priority_processing: {
                        id: boxPrices['7042789048476'].pp.id,
                        price: boxPrices['7042789048476'].pp.price,
                        selling_plan: 1163853980
                    }
                }
            }
        }
    },
    'deluxe': {
        id: 3,
        name: 'Deluxe',
        snacks: "15-18",
        drinks: 1,
        monthly: {
            id: 7042799927452,
            variants: {
                regular: {
                    id: boxPrices['7042799927452'].regular.id,
                    price: boxPrices['7042799927452'].regular.price,
                    selling_plan: 1164017820
                },
                priority_processing: {
                    id: boxPrices['7042799927452'].pp.id,
                    price: boxPrices['7042799927452'].pp.price,
                    selling_plan: 1164017820
                }
            }
        },
        prepay: {
            "3": {
                id: 7042803400860,
                months: 3,
                variants: {
                    regular: {
                        id: boxPrices['7042803400860'].regular.id,
                        price: boxPrices['7042803400860'].regular.price,
                        selling_plan: 1162051740
                    },
                    priority_processing: {
                        id: boxPrices['7042803400860'].pp.id,
                        price: boxPrices['7042803400860'].pp.price,
                        selling_plan: 1162051740
                    }
                }
            },
            "6": {
                id: 7042853306524,
                months: 6,
                variants: {
                    regular: {
                        id: boxPrices['7042853306524'].regular.id,
                        price: boxPrices['7042853306524'].regular.price,
                        selling_plan: 1163526300
                    },
                    priority_processing: {
                        id: boxPrices['7042853306524'].pp.id,
                        price: boxPrices['7042853306524'].pp.price,
                        selling_plan: 1163526300
                    }
                }
            },
            "12": {
                id: 7042806120604,
                months: 12,
                variants: {
                    regular: {
                        id: boxPrices['7042806120604'].regular.id,
                        price: boxPrices['7042806120604'].regular.price,
                        selling_plan: 1162477724
                    },
                    priority_processing: {
                        id: boxPrices['7042806120604'].pp.id,
                        price: boxPrices['7042806120604'].pp.price,
                        selling_plan: 1162477724
                    }
                }
            }
        }
    }
    // 'motherload': {
    //     name: 'Motherload',
    //     snacks: "60-72",
    //     drinks: 4,
    //     monthly: {
    //         id: 7042810675356,
    //         variants: {
    //             regular: {
    //                 id: boxPrices['7042810675356'].regular.id,
    //                 price: boxPrices['7042810675356'].regular.price,
    //                 selling_plan: 1164050588
    //             },
    //             priority_processing: {
    //                 id: boxPrices['7042810675356'].pp.id,
    //                 price: boxPrices['7042810675356'].pp.price,
    //                 selling_plan: 1164050588
    //             }
    //         }
    //     },
    //     prepay: {
    //         "3": {
    //             id: 7042812641436,
    //             months: 3,
    //             variants: {
    //                 regular: {
    //                     id: boxPrices['7042812641436'].regular.id,
    //                     price: boxPrices['7042812641436'].regular.price,
    //                     selling_plan: 1163886748
    //                 },
    //                 priority_processing: {
    //                     id: boxPrices['7042812641436'].pp.id,
    //                     price: boxPrices['7042812641436'].pp.price,
    //                     selling_plan: 1163886748
    //                 }
    //             }
    //         },
    //         "6": {
    //             id: 7042814214300,
    //             months: 6,
    //             variants: {
    //                 regular: {
    //                     id: boxPrices['7042814214300'].regular.id,
    //                     price: boxPrices['7042814214300'].regular.price,
    //                     selling_plan: 1162576028
    //                 },
    //                 priority_processing: {
    //                     id: boxPrices['7042814214300'].pp.id,
    //                     price: boxPrices['7042814214300'].pp.price,
    //                     selling_plan: 1162576028
    //                 }
    //             }
    //         },
    //         "12": {
    //             id: 7042816770204,
    //             months: 12,
    //             variants: {
    //                 regular: {
    //                     id: boxPrices['7042816770204'].regular.id,
    //                     price: boxPrices['7042816770204'].regular.price,
    //                     selling_plan: 1162182812
    //                 },
    //                 priority_processing: {
    //                     id: boxPrices['7042816770204'].pp.id,
    //                     price: boxPrices['7042816770204'].pp.price,
    //                     selling_plan: 1162182812
    //                 }
    //             }
    //         }
    //     }
    // }
}

var koreaBoxItems = {
    'standard': {
        id: 1,
        name: 'Standard',
        snacks: 6,
        drinks: 0,
        monthly: {
            id: 6001316364444,
            variants: {
                regular: {
                    id: boxPrices['6001316364444'].regular.id,
                    price: boxPrices['6001316364444'].regular.price,
                    selling_plan: 1163493532
                },
                priority_processing: {
                    id: boxPrices['6001316364444'].pp.id,
                    price: boxPrices['6001316364444'].pp.price,
                    selling_plan: 1163493532
                }
            }
        },
        prepay: {
            "3": {
                id: 6001318920348,
                months: 3,
                variants: {
                    regular: {
                        id: boxPrices['6001318920348'].regular.id,
                        price: boxPrices['6001318920348'].regular.price,
                        selling_plan: 1162969244
                    },
                    priority_processing: {
                        id: boxPrices['6001318920348'].pp.id,
                        price: boxPrices['6001318920348'].pp.price,
                        selling_plan: 1162969244
                    }
                }
            },
            "6": {
                id: 6001321476252,
                months: 6,
                variants: {
                    regular: {
                        id: boxPrices['6001321476252'].regular.id,
                        price: boxPrices['6001321476252'].regular.price,
                        selling_plan: 1162838172
                    },
                    priority_processing: {
                        id: boxPrices['6001321476252'].pp.id,
                        price: boxPrices['6001321476252'].pp.price,
                        selling_plan: 1162838172
                    }
                }
            },
            "12": {
                id: 6001323671708,
                months: 12,
                variants: {
                    regular: {
                        id:  boxPrices['6001323671708'].regular.id,
                        price: boxPrices['6001323671708'].regular.price,
                        selling_plan: 1163591836
                    },
                    priority_processing: {
                        id: boxPrices['6001323671708'].pp.id,
                        price: boxPrices['6001323671708'].pp.price,
                        selling_plan: 1163591836
                    }
                }
            }
        }
    },
    'premium': {
        id: 2,
        name: 'Premium',
        snacks: 12,
        drinks: 1,
        monthly: {
            id: 8273889788060,
            variants: {
                regular: {
                    id: boxPrices['8273889788060'].regular.id,
                    price: boxPrices['8273889788060'].regular.price,
                    selling_plan: 1163395228
                },
                priority_processing: {
                    id: boxPrices['8273889788060'].pp.id,
                    price: boxPrices['8273889788060'].pp.price,
                    selling_plan: 1163395228
                }
            }
        },
        prepay: {
            "3": {
                id: 6001330421916,
                months: 3,
                variants: {
                    regular: {
                        id: boxPrices['6001330421916'].regular.id,
                        price: boxPrices['6001330421916'].regular.price,
                        selling_plan: 1163067548
                    },
                    priority_processing: {
                        id: boxPrices['6001330421916'].pp.id,
                        price: boxPrices['6001330421916'].pp.price,
                        selling_plan: 1163067548
                    }
                }
            },
            "6": {
                id: 6001332387996,
                months: 6,
                variants: {
                    regular: {
                        id: boxPrices['6001332387996'].regular.id,
                        price: boxPrices['6001332387996'].regular.price,
                        selling_plan: 1162510492
                    },
                    priority_processing: {
                        id: boxPrices['6001332387996'].pp.id,
                        price: boxPrices['6001332387996'].pp.price,
                        selling_plan: 1162510492
                    }
                }
            },
            "12": {
                id: 6001333895324,
                months: 12,
                variants: {
                    regular: {
                        id: boxPrices['6001333895324'].regular.id,
                        price: boxPrices['6001333895324'].regular.price,
                        selling_plan: 1163264156
                    },
                    priority_processing: {
                        id: boxPrices['6001333895324'].pp.id,
                        price: boxPrices['6001333895324'].pp.price,
                        selling_plan: 1163264156
                    }
                }
            }
        }
    }
}


var munchGiftBoxItems = {
    'standard': {
        id: 1,
        name: 'Standard',
        snacks: "5-7",
        drinks: 0,
        prepay: {
            "6": {
                id: 7042825420956,
                months: 6,
                variants: {
                    regular: {
                        id: boxPrices['7042825420956'].regular.id,
                        price: boxPrices['7042825420956'].regular.price,
                        selling_plan: 1162805404
                    },
                    priority_processing: {
                        id: boxPrices['7042825420956'].pp.id,
                        price: boxPrices['7042825420956'].pp.price,
                        selling_plan: 1162805404
                    }
                }
            },
            "12": {
                id: 7042831810716,
                months: 12,
                variants: {
                    regular: {
                        id: boxPrices['7042831810716'].regular.id,
                        price: boxPrices['7042831810716'].regular.price,
                        selling_plan: 1163362460
                    },
                    priority_processing: {
                        id: boxPrices['7042831810716'].pp.id,
                        price: boxPrices['7042831810716'].pp.price,
                        selling_plan: 1163362460
                    }
                }
            }
        }
    },
    'premium': {
        id: 2,
        name: 'Premium',
        snacks: "10-12",
        drinks: 0,
        prepay: {
            "3": {
                id: 7042833711260,
                months: 3,
                variants: {
                    regular: {
                        id: boxPrices['7042833711260'].regular.id,
                        price: boxPrices['7042833711260'].regular.price,
                        selling_plan: 1163231388
                    },
                    priority_processing: {
                        id: boxPrices['7042833711260'].pp.id,
                        price: boxPrices['7042833711260'].pp.price,
                        selling_plan: 1163231388
                    }
                }
            },
            "6": {
                id: 7042835251356,
                months: 6,
                variants: {
                    regular: {
                        id: boxPrices['7042835251356'].regular.id,
                        price: boxPrices['7042835251356'].regular.price,
                        selling_plan: 1163755676
                    },
                    priority_processing: {
                        id: boxPrices['7042835251356'].pp.id,
                        price: boxPrices['7042835251356'].pp.price,
                        selling_plan: 1163755676
                    }
                }
            },
            "12": {
                id: 7042836824220,
                months: 12,
                variants: {
                    regular: {
                        id: boxPrices['7042836824220'].regular.id,
                        price: boxPrices['7042836824220'].regular.price,
                        selling_plan: 1162412188
                    },
                    priority_processing: {
                        id: boxPrices['7042836824220'].pp.id,
                        price: boxPrices['7042836824220'].pp.price,
                        selling_plan: 1162412188
                    }
                }
            }
        }
    },
    'deluxe': {
        id: 3,
        name: 'Deluxe',
        snacks: "15-18",
        drinks: 1,
        monthly: {
            id: 7042840363164,
            variants: {
                regular: {
                    id: boxPrices['7042840363164'].regular.id,
                    price: boxPrices['7042840363164'].regular.price
                },
                priority_processing: {
                    id: boxPrices['7042840363164'].pp.id,
                    price: boxPrices['7042840363164'].pp.price
                }
            }
        },
        prepay: {
            "3": {
                id: 7042842165404,
                months: 3,
                variants: {
                    regular: {
                        id: boxPrices['7042842165404'].regular.id,
                        price: boxPrices['7042842165404'].regular.price,
                        selling_plan: 1163002012
                    },
                    priority_processing: {
                        id:  boxPrices['7042842165404'].pp.id,
                        price: boxPrices['7042842165404'].pp.price,
                        selling_plan: 1163002012
                    }
                }
            },
            "6": {
                id: 7042804875420,
                months: 6,
                variants: {
                    regular: {
                        id:  boxPrices['7042804875420'].regular.id,
                        price: boxPrices['7042804875420'].regular.price,
                        selling_plan: 1162084508
                    },
                    priority_processing: {
                        id: boxPrices['7042804875420'].pp.id,
                        price: boxPrices['7042804875420'].pp.price,
                        selling_plan: 1162084508
                    }
                }
            },
            "12": {
                id: 7042843771036,
                months: 12,
                variants: {
                    regular: {
                        id: boxPrices['7042843771036'].regular.id,
                        price: boxPrices['7042843771036'].regular.price,
                        selling_plan: 1162674332
                    },
                    priority_processing: {
                        id: boxPrices['7042843771036'].pp.id,
                        price: boxPrices['7042843771036'].pp.price,
                        selling_plan: 1162674332
                    }
                }
            }
        }
    }
    // 'motherload': {
    //     name: 'Motherload',
    //     snacks: "60-72",
    //     drinks: 4,
    //     monthly: {
    //         id: 7042844983452,
    //         variants: {
    //             regular: {
    //                 id: boxPrices['7042844983452'].regular.id,
    //                 price: boxPrices['7042844983452'].regular.price
    //             },
    //             priority_processing: {
    //                 id: boxPrices['7042844983452'].pp.id,
    //                 price: boxPrices['7042844983452'].pp.price
    //             }
    //         }
    //     },
    //     prepay: {
    //         "3": {
    //             id: 7042846720156,
    //             months: 3,
    //             variants: {
    //                 regular: {
    //                     id: boxPrices['7042846720156'].regular.id,
    //                     price: boxPrices['7042846720156'].regular.price,
    //                     selling_plan: 1163460764
    //                 },
    //                 priority_processing: {
    //                     id: boxPrices['7042846720156'].pp.id,
    //                     price: boxPrices['7042846720156'].pp.price,
    //                     selling_plan: 1163460764
    //                 }
    //             }
    //         },
    //         "6": {
    //             id: 7042847178908,
    //             months: 6,
    //             variants: {
    //                 regular: {
    //                     id: boxPrices['7042847178908'].regular.id,
    //                     price: boxPrices['7042847178908'].regular.price,
    //                     selling_plan: 1163165852
    //                 },
    //                 priority_processing: {
    //                     id: boxPrices['7042847178908'].pp.id,
    //                     price: boxPrices['7042847178908'].pp.price,
    //                     selling_plan: 1163165852
    //                 }
    //             }
    //         },
    //         "12": {
    //             id: 7042847998108,
    //             months: 12,
    //             variants: {
    //                 regular: {
    //                     id: boxPrices['7042847998108'].regular.id,
    //                     price: boxPrices['7042847998108'].regular.price,
    //                     selling_plan: 1162608796
    //                 },
    //                 priority_processing: {
    //                     id: boxPrices['7042847998108'].pp.id,
    //                     price: boxPrices['7042847998108'].pp.price,
    //                     selling_plan: 1162608796
    //                 }
    //             }
    //         }
    //     }
    // }
}

var koreaGiftBoxItems = {
    'standard': {
        id: 1,
        name: 'Standard',
        snacks: 6,
        drinks: 0,
        prepay: {
            "3": {
                id: 7052119376028,
                months: 3,
                variants: {
                    regular: {
                        id: boxPrices['7052119376028'].regular.id,
                        price: boxPrices['7052119376028'].regular.price,
                        selling_plan: 1163722908
                    },
                    priority_processing: {
                        id: boxPrices['7052119376028'].pp.id,
                        price: boxPrices['7052119376028'].pp.price,
                        selling_plan: 1163722908
                    }
                }
            },
            "6": {
                id: 7052120653980,
                months: 6,
                variants: {
                    regular: {
                        id: boxPrices['7052120653980'].regular.id,
                        price: boxPrices['7052120653980'].regular.price,
                        selling_plan: 1162739868
                    },
                    priority_processing: {
                        id: boxPrices['7052120653980'].pp.id,
                        price: boxPrices['7052120653980'].pp.price,
                        selling_plan: 1162739868
                    }
                }
            },
            "12": {
                id: 7052119769244,
                months: 12,
                variants: {
                    regular: {
                        id: boxPrices['7052119769244'].regular.id,
                        price: boxPrices['7052119769244'].regular.price,
                        selling_plan: 1163624604
                    },
                    priority_processing: {
                        id: boxPrices['7052119769244'].pp.id,
                        price: boxPrices['7052119769244'].pp.price,
                        selling_plan: 1163624604
                    }
                }
            }
        }
    },
    'premium': {
        id: 2,
        name: 'Premium',
        snacks: 12,
        drinks: 1,
        monthly: {
            id: 8273891000476,
            variants: {
                regular: {
                    id: boxPrices['8273891000476'].regular.id,
                    price: boxPrices['8273891000476'].regular.price,
                    selling_plan: 1162150044
                },
                priority_processing: {
                    id: boxPrices['8273891000476'].regular.id,
                    price: boxPrices['8273891000476'].pp.price,
                    selling_plan: 1162150044
                }
            }
        },
        prepay: {
            "3": {
                id: 7052117082268,
                months: 3,
                variants: {
                    regular: {
                        id: boxPrices['7052117082268'].regular.id,
                        price: boxPrices['7052117082268'].regular.price,
                        selling_plan: 1163559068
                    },
                    priority_processing: {
                        id: boxPrices['7052117082268'].pp.id,
                        price: boxPrices['7052117082268'].pp.price,
                        selling_plan: 1163559068
                    }
                }
            },
            "6": {
                id: 7052118655132,
                months: 6,


                variants: {
                    regular: {
                        id: boxPrices['7052118655132'].regular.id,
                        price: boxPrices['7052118655132'].regular.price,
                        selling_plan: 1163100316
                    },
                    priority_processing: {
                        id: boxPrices['7052118655132'].pp.id,
                        price: boxPrices['7052118655132'].pp.price,
                        selling_plan: 1163100316
                    }
                }
            },
            "12": {
                id: 7052112560284,
                months: 12,
                variants: {
                    regular: {
                        id: boxPrices['7052112560284'].regular.id,
                        price: boxPrices['7052112560284'].regular.price,
                        selling_plan: 1162281116
                    },
                    priority_processing: {
                        id: boxPrices['7052112560284'].pp.id,
                        price: boxPrices['7052112560284'].pp.price,
                        selling_plan: 1162281116
                    }
                }
            }
        }
    }
}

var ramenBoxItems = {
    'regular': {
        id: 1,
        name: 'Ramen Box',
        snacks: 9,
        drinks: 0,
        product: {
            id: 7048160739484,
            variants: {
                regular: {
                    id: boxPrices['7048160739484'].regular.id,
                    price: boxPrices['7048160739484'].regular.price
                },
                priority_processing: {
                    id: boxPrices['7048160739484'].pp.id,
                    price: boxPrices['7048160739484'].pp.price
                }
            }
        }
    }
}

var ramenGiftBoxItems = {
    'regular': {
        id: 1,
        name: 'Ramen Box',
        snacks: 9,
        drinks: 0,
        product: {
            id: 7052201525404,
            variants: {
                regular: {
                    id: boxPrices['7052201525404'].regular.id,
                    price: boxPrices['7052201525404'].regular.price
                },
                priority_processing: {
                    id: boxPrices['7052201525404'].pp.id,
                    price: boxPrices['7052201525404'].pp.price
                }
            }
        }
    }
}

var mexicoBoxItems = {
    'regular': {
        id: 1,
        name: 'Mexico Box',
        snacks: 15,
        drinks: 0,
        product: {
            id: 7048217100444,
            variants: {
                regular: {
                    id: boxPrices['7048217100444'].regular.id,
                    price: boxPrices['7048217100444'].regular.price
                },
                priority_processing: {
                    id: boxPrices['7048217100444'].pp.id,
                    price: boxPrices['7048217100444'].pp.price
                }
            }
        }
    }
}

var mexicoGiftBoxItems = {
    'regular': {
        id: 1,
        name: 'Mexico Gift Box',
        snacks: 15,
        drinks: 0,
        product: {
            id: 7052199755932,
            variants: {
                regular: {
                    id: boxPrices['7052199755932'].regular.id,
                    price: boxPrices['7052199755932'].regular.price
                },
                priority_processing: {
                    id: boxPrices['7052199755932'].pp.id,
                    price: boxPrices['7052199755932'].pp.price
                }
            }
        }
    }
}

var koreaBoxItems2 = {
    'regular': {
        id: 1,
        name: 'Korea Box',
        snacks: 12,
        drinks: 1,
        product: {
            id: 8273889788060,
            variants: {
                regular: {
                    id: boxPrices['8273889788060'].regular.id,
                    price: boxPrices['8273889788060'].regular.price
                },
                priority_processing: {
                    id: boxPrices['8273889788060'].pp.id,
                    price: boxPrices['8273889788060'].pp.price
                }
            }
        }
    }
}

var koreaGiftBoxItems2 = {
    'regular': {
        id: 1,
        name: 'Korea Box',
        snacks: 12,
        drinks: 1,
        product: {
            id: 8273891000476,
            variants: {
                regular: {
                    id: 44563116818588,
                    price: 50.00
                },
                priority_processing: {
                    id: 44563182780572,
                    price: 53.00
                }
            }
        }
    }
}

var drinkItems = {
    "1": {
        id: boxPrices['7157967454364'].regular.id,
        price: boxPrices['7157967454364'].regular.price,
        selling_plan: 1163657372
    },
    "3": {
        id: boxPrices['7158741565596'].regular.id,
        price: boxPrices['7158741565596'].regular.price,
        selling_plan: 1163985052
    },
    "6": {
        id: boxPrices['7158742057116'].regular.id,
        price: boxPrices['7158742057116'].regular.price,
        selling_plan: 1163919516
    },
    "12": {
        id: boxPrices['7158742352028'].regular.id,
        price: boxPrices['7158742352028'].regular.price,
        selling_plan: 1162641564
    }
}

var drinkGiftItems = {
    "1": {
        id: boxPrices['7647516950684'].regular.id,
        price: boxPrices['7647516950684'].regular.price,
        selling_plan: 1164083356
    },
    "3": {
        id: boxPrices['7647517245596'].regular.id,
        price: boxPrices['7647517245596'].regular.price,
        selling_plan: 1164148892
    },
    "6": {
        id: boxPrices['7647517376668'].regular.id,
        price: boxPrices['7647517376668'].regular.price,
        selling_plan: 1164181660
    },
    "12": {
        id: boxPrices['7647517180060'].regular.id,
        price: boxPrices['7647517180060'].regular.price,
        selling_plan: 1164116124
    }
}